import { isMockServices } from 'src/utils';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import mock from '../utils/mock';

export interface SyncUserTenantsParams {
  userId: string;
  tenantIds: string[];
}

/**
 * Sync allowed tenants for a user in one request.
 * Backend applies adds first, then removes, so order is guaranteed.
 */
const syncUserTenants = async (
  args: SyncUserTenantsParams,
): Promise<boolean> => {
  if (isMockServices()) return await mock(true, { delay: 500, failureRate: 0 });

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean }>(
    `/shared/users/${args.userId}/allowed-tenants`,
    {
      method: 'PUT',
      body: { tenantIds: args.tenantIds },
    },
  );
  if (response.data) return response.data.success;
  throw new Error('Failed to sync user tenants');
};

export default syncUserTenants;
